import {useEffect} from "react"
import useSWR from "swr"

import SubHeader from "../components/SubHeader"
import {fetcherGet} from "../utilities/general"
import {wrappedGet, wrappedPost} from "../utilities/AxiosHelper"

const adoptUser = async (userId) => {
    await wrappedPost("auth/adopt-user", {
        user_id: userId,
    })

    const response = await wrappedGet("me")
    const user = response.data

    sessionStorage.setItem("user_id", user.user_id)
    sessionStorage.setItem("display_name", user.display_name)
    sessionStorage.setItem("user_name", user.user_name)
    sessionStorage.setItem("is_admin", user.is_admin)
    sessionStorage.setItem("role", user.role)

    sessionStorage.setItem("real_user_id", user.real_user_id)
    sessionStorage.setItem("acting_as", user.acting_as)
    sessionStorage.setItem("organization_id", user.acting_as_organization_id)

    // TODO how to handle datadog
    // datadogRum.setUser({
    // 	id: user.user_id,
    // 	name: user.user_name,
    // 	email: user.email,
    // 	role: user.role,
    // })

    window.location.href = "/home"
}

const AdoptPersona = () => {
    const {data: users} = useSWR("/auth/adoptable-users", fetcherGet, {fallbackData: []})

    useEffect(() => {
        document.title = `Adopt Persona`
    }, [])

    return (
        <>
            <SubHeader title1="OARS" title2="Adopt Testing User" icon="fa-user-secret" />

            <div className="container-fluid d-flex flex-wrap justify-content-between row-gap-5 mt-10">
                {users.map((user) => (
                    <div
                        key={user.id}
                        className="card cursor-pointer w-100 w-md-400px mw-100"
                        onClick={() => adoptUser(user.id)}
                    >
                        <div className="card-body text-center">
                            <i className="fas fa-user-circle fs-1 text-primary mb-3"></i>

                            <h5 className="mb-1">{user.account}</h5>

                            <div className="text-muted fs-7">{user.role_name}</div>
							<div className="text-muted fs-7">
								{user.facilities.join(", ")}
							</div>

							<div className="text-muted fs-7">
								{user.units.join(", ")}
							</div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default AdoptPersona
